export type Routes = {
  [key: string]: any
}

class RouteManager {
  private _routes: Routes = {}

  init(routes: Routes) {
    this._routes = routes
  }

  get routes() {
    return this._routes
  }

  clearRoutes() {
    this._routes = {}
  }
}

export default RouteManager
